<template>
    <div  class="risposta-container">
    <label :class="this.className">
        <span class="btn-label fs-1 mb-1">
          <i class="bi bi-caret-right"></i>
        </span> 
        <input class="btn-answer" :onclick="!this.answerData.disableClick ? () => this.onClickCallback(this.answerData,true) : null" type="radio" name="q_answer" :value="answerData.id">{{this.text || intl[$store.state.lang][this.textId] }}
    </label>
    </div>
</template>

<script>
import intl from "./intl/intl";

export default {
    name: "risposta",
    mounted() {
        console.log("ANSWERDATA: ",this.answerData)
    },
    props: {
        text: {
            type: String,
            default: null,
        },
        rispostaId: {
            type: String,
            default: null,
        },
        answerData: {
            type: Object,
            default: null
        },
        className: {
            type: String,
            default: null,
        },
        onClickCallback:  {
            type: Function,
            default: (answerData,saveLogDone) => {
                console.log("DATI RISPOSTA: ",answerData)
            },
        },
        
    },

    data: function () {
        return {
            intl: intl,
            
            
        };
    },
    methods: {
        
    },
    watch: {
        /* name: function(newVal, oldVal) { 
          this.newName = newVal
        }, */
        
    },
    computed: {
        textId(){
            return this.rispostaId + ".text"
        }
    },
};
</script>
